module.exports = __webpack_public_path__ + "6e70651fa0bb451b5b12d30368dafc6b.jpg";